import { AxiosError } from 'axios';
import { AuthErrorCodes, HTTP_STATUS_TO_AUTH_ERROR } from 'constants/auth-error.constants';

export interface ClassifiedLocalAuthError {
    errorMessage: string | unknown;
    errorCode?: AuthErrorCodes;
}

export const classifyLocalAuthError = (error: unknown): ClassifiedLocalAuthError => {
    let errorMessage: string | unknown;

    if (error instanceof Error) {
        errorMessage = error.toString();
    } else if (error) {
        errorMessage = error;
    } else {
        errorMessage = AuthErrorCodes.GENERIC;
    }

    const axiosError = error as AxiosError | undefined;

    if (!axiosError?.response) {
        return { errorMessage };
    }

    const status = axiosError.response.status;
    const errorCode = HTTP_STATUS_TO_AUTH_ERROR[status];

    return { errorMessage, errorCode };
};
